import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";
interface MessageContext {
  title: string;
  messageCode: string;
  messageType: string;
  content: string;
  category: string;
}

interface OnboardingMessagesResponse {
  messageContext: MessageContext[];
}

export const getOnboardingUIMessages = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOnboardingUIMessages: builder.query<OnboardingMessagesResponse, string>({
      query: (preferredLanguage) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;

        return {
          url: "/api/v1/Patient/ui-messages",
          method: "GET",
          headers,
        };
      },
    }),
  }),
});

export const { useGetOnboardingUIMessagesQuery } = getOnboardingUIMessages;
